import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { ITransparencyItem } from './Transparency.types'
import cn from 'classnames'
import { ContentfulNextJsImage } from '@components/common/ContentfulImage'
import closeBtn from '@public/aboutus/close.svg'

interface ITransparencyPopup {
  open: boolean
  headingClassName: string
  transparency: ITransparencyItem
  onClose: () => void
}

export function TransparencyPopup({
  open,
  headingClassName,
  transparency,
  onClose,
}: ITransparencyPopup) {
  if (!open) {
    return null
  }
  return (
    <>
      <div
        className="fixed inset-0 z-10 overflow-auto bg-black opacity-60"
        onClick={onClose}
      ></div>
      <div
        className={cn(
          'p-8 bg-core-grey-40 w-[86%] max-w-[831px] shadow-[0_2px_30px_0_rgba(178,178,178,0.5)]',
          'transform -translate-x-1/2 -translate-y-[35%] rounded-xl fixed top-2/4 left-2/4 z-20 md:w-full md:p-4'
        )}
      >
        <div className="text-center">
          <span
            className={cn(
              '-top-8 -right-[8px] w-[17px] h-[17px] transform translate-x-1/2 -translate-y-1/2',
              'bg-transparent font-normal left-auto cursor-pointer pt-1 inline-block absolute',
              'md:-right-8 md:-top-[18px] md:w-[37px] md:h-[37px]'
            )}
            onClick={onClose}
          >
            <ContentfulNextJsImage
              alt="Close"
              src={closeBtn}
              layout="responsive"
              width={29}
              height={29} // FIXME: No image optimized?
            />
          </span>
          <div>
            <h2
              className={cn(
                'text-center text-5xl md:text-4xl font-bold',
                headingClassName
              )}
            >
              {transparency.heading}
              <span className="inline-block w-full mb-6 text-2xl font-normal text-content-base">
                {transparency.subHeading}
              </span>
            </h2>
            <div className="flex justify-center my-2 md:mb-9 md:mt-8">
              <div className="rounded-full w-[130px] shadow-[0_3px_30px_0_rgba(161,161,161,0.5)] md:w-[189px]">
                <ContentfulNextJsImage
                  alt={transparency.mainImage?.imageTitle}
                  src={transparency.mainImage?.imageUrl}
                  layout="responsive"
                  width={100}
                  height={100} // FIXME: No image optimized?
                />
              </div>
            </div>
            <div className="flex flex-wrap overflow-y-auto max-h-[250px] text-left text-xl -mx-[12px] my-0 justify-between px-3">
              <ContentfulMarkdown
                overrideStyles={{
                  p: ({ children }) => (
                    <p className="mb-6 text-core-grey-80">{children}</p>
                  ),
                  h3: ({ children }) => (
                    <h4 className="font-bold min-h-[80px] text-acai">
                      {children}
                    </h4>
                  ),
                }}
              >
                {transparency.descriptions}
              </ContentfulMarkdown>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
